import React from 'react';
import { injectIntl } from 'react-intl';
import { adaptGameToContainer, i18nIntl, isNotEmpty } from '../../lib/ep.js';

import { useCanvasMachine } from '../../ts/games/canvasStateMachine.ts';
import LikeDislikeFinalCanvas from '../games/LikeDislikeFinalCanvas.js';
import LeveledHTMLText from './helpers/LeveledHTMLText.js';
import ActionButton from '../builder/ActionButton.js';

const LikeDislikeShare = ({ stage, promotion, user, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const is_builder = props?.is_builder ?? false;

	const players = isNotEmpty(stage, 'likedislike_players') ? stage.likedislike_players : [];

	const canvas_images = () => {
		const images = [];

		if(isNotEmpty(stage, 'full_game_final_bg_image')) {
			images.push({
				id:'final_bg_img',
				name:stage.game_final_bg_image,
				url:stage.full_game_final_bg_image,
				image:stage.full_game_final_bg_image,
				fit:'cover',
			});
		}

		if(isNotEmpty(stage, 'likedislike_like_image')) {
			images.push({
				id:`like_icon`,
				name:stage.likedislike_like_image,
				url:stage.full_likedislike_like_image,
				image:stage.full_likedislike_like_image,
				fit:'contain',
			});
		}

		if(isNotEmpty(stage, 'likedislike_dislike_image')) {
			images.push({
				id:`dislike_icon`,
				name:stage.likedislike_dislike_image,
				url:stage.full_likedislike_dislike_image,
				image:stage.full_likedislike_dislike_image,
				fit:'contain',
			});
		}

		players.map((player) => {
			if(isNotEmpty(player, 'image')) {
				images.push({
					id:`player_${player.id}`,
					name:player.image,
					url:player.full_image,
					image:player.full_image,
					fit:'contain',
				});
			}
		});

		return images;
	};

	const [ state, dispatch ] = useCanvasMachine({
		images:canvas_images,
		images_dependencies:[
			stage.likedislike_players,
			stage.likedislike_like_image,
			stage.likedislike_dislike_image,
			stage.final_bg_img,
		],
	});

	let user_name = i18n("Option");
	if(!is_builder) {
		user_name = (promotion.need_nickname != undefined && promotion.need_nickname == '1') ? user.name : (isNotEmpty(user, 'first_name') ? user.first_name : user.name.split(" ")[0]);
	}

	const main_description_placeholder = `<h1>${i18n("The choice of {name}")}</h1><p>${i18n("Join in, select your favorite option, and check how the results are going.")}</p>`;

	const final_message = (isNotEmpty(stage, 'game_shared_description', [""])) ? stage.game_shared_description : main_description_placeholder;

	const button_cta = (isNotEmpty(stage, 'game_shared_button_label')) ? stage.game_shared_button_label : i18n("Make my choice");

	return (
		<div style={{ display:'grid', gap:'2em', maxWidth:'600px' }}>
			{(final_message != " ") && (
				<LeveledHTMLText>{final_message.replace("{name}", user_name)}</LeveledHTMLText>
			)}

			<div class="final_image" style={{ maxWidth:'unset' }}>
				<LikeDislikeFinalCanvas
					{...props}
					stage={stage}
					user_answer={user?.quiz_entry?.likedislike ?? []}
					indexed_images={state.images}
					loaded_status={state.state}
					adaptToContainer={adaptGameToContainer}
				/>
			</div>

			<article class="team_cta template_module info_flexwrap gui_main_actions">
				<div class="template_submodule call_to_action_flex enter_flexwrap">
					<div class="enter flex_button gui_big_button register_flex">
						<ActionButton
							_fullclass=""
							_href={`/p/${promotion.id}`}
							autotranslate={false}
						>{button_cta}</ActionButton>
					</div>
				</div>
			</article>
		</div>
	);
};

export default injectIntl(LikeDislikeShare);